export default {"src":"/_next/static/media/trending_logo.3ae10419.svg","height":267,"width":267,"blurWidth":0,"blurHeight":0};